import isElectron from 'is-electron';
import { CookiesState } from '../components/RequireCookies/RequireCookies';

export type StorageKeys =
  | 'allow-cookies'
  | 'APP_FILTERS'
  | 'mapType'
  | 'useCoreApi'
  | 'coreApiAccessToken'
  | 'coreApiRefreshToken'
  | 'coreApiSessionId'
  | 'csrf'
  | 'TEST_API_URL'
  | 'recheckTimeOut'
  | 'CREATE_CEC_MESSAGE'
  | 'selectedLang'
  | 'language'
  | 'isLoneWorkTimerActive'
  | 'didAskedToGoMobileApp'
  | 'panicButtonData'
  | 'pushyToken'
  | 'selectedRegion'
  | 'tenantSessions'
  | 'activeTenantId';

export const sessionStorageSet = (key: StorageKeys, item: string) => {
  sessionStorage.setItem(key, item);
};

export const sessionStorageGet = (key: StorageKeys) => {
  return sessionStorage.getItem(key);
};

export const sessionStorageRemove = (key: StorageKeys) => {
  sessionStorage.removeItem(key);
};

export const localStorageSet = (key: StorageKeys, item: string) => {
  localStorage.setItem(key, item);
};

export const localStorageGet = (key: StorageKeys) => {
  return localStorage.getItem(key);
};

export const localStorageRemove = (key: StorageKeys) => {
  localStorage.removeItem(key);
};

export const setItem = (key: StorageKeys, item: object | string | boolean) => {
  const hasAcceptedCookies = localStorageGet('allow-cookies') === CookiesState.accepted;
  const itemString = JSON.stringify(item);
  // Always use localStorage for electron, since we don't show cookies banner in desktop apps
  if (isElectron() || hasAcceptedCookies) {
    localStorageSet(key, itemString);
  } else {
    sessionStorageSet(key, itemString);
  }
};

export const getItem = (key: StorageKeys) => {
  const hasAcceptedCookies = localStorageGet('allow-cookies') === CookiesState.accepted;
  const item = isElectron() || hasAcceptedCookies ? localStorageGet(key) : sessionStorageGet(key);

  let itemObject;
  if (item) {
    try {
      itemObject = JSON.parse(item);
    } catch {
      itemObject = null;
      console.error('Not valid JSON');
    }
  }

  return itemObject;
};

export const removeItem = (key: StorageKeys) => {
  const hasAcceptedCookies = localStorageGet('allow-cookies') === CookiesState.accepted;
  if (isElectron() || hasAcceptedCookies) {
    localStorageRemove(key);
  } else {
    sessionStorageRemove(key);
  }
};
